/**
 * ThemeToggle (1.36.0) — переключатель «Тёмная / Светлая».
 *
 * Компактный сегментированный контрол. Используется в топбаре админки.
 * Цвета берутся из активной палитры, поэтому сам контрол выглядит уместно
 * в обеих темах.
 */

import { C, F, useThemeStore, type ThemeName } from '../tokens';

const OPTIONS: { key: ThemeName; label: string }[] = [
  { key: 'dark',  label: 'Тёмная' },
  { key: 'light', label: 'Светлая' },
];

export function ThemeToggle({ compact = false, fullWidth = false }: { compact?: boolean; fullWidth?: boolean }) {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  return (
    <div
      role="group"
      aria-label="Тема оформления"
      style={{
        display: fullWidth ? 'flex' : 'inline-flex',
        width: fullWidth ? '100%' : undefined,
        gap: 3,
        background: C.surf,
        border: `1px solid ${C.b}`,
        borderRadius: 10,
        padding: 3,
      }}
    >
      {OPTIONS.map((opt) => {
        const active = theme === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            onClick={() => setTheme(opt.key)}
            aria-pressed={active}
            title={opt.label}
            style={{
              border: 'none',
              cursor: 'pointer',
              fontFamily: F.head,
              fontWeight: 700,
              fontSize: compact ? 11 : 12.5,
              padding: compact ? '6px 10px' : '7px 14px',
              borderRadius: 7,
              flex: fullWidth ? 1 : undefined,
              background: active ? C.acc : 'transparent',
              color: active ? '#fff' : C.sub,
              transition: 'background .14s, color .14s',
              whiteSpace: 'nowrap',
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
